import { apiCall } from "./firebase";
import { Priority, CreatePriorityData, UpdatePriorityData, PriorityStats } from "../types";

export class PriorityService {
  async getPriorities(): Promise<Priority[]> {
    try {
      const response = await apiCall("/getPriorities");
      return response.priorities || [];
    } catch (error) {
      console.error("Error fetching priorities:", error);
      throw error;
    }
  }

  async createPriority(data: CreatePriorityData): Promise<Priority> {
    try {
      const response = await apiCall("/createPriority", {
        method: "POST",
        body: JSON.stringify(data),
      });
      return response.priority;
    } catch (error) {
      console.error("Error creating priority:", error);
      throw error;
    }
  }

  async updatePriority(priorityId: string, data: UpdatePriorityData): Promise<Priority> {
    try {
      const response = await apiCall("/updatePriority", {
        method: "POST",
        body: JSON.stringify({ priorityId, ...data }),
      });
      return response.priority;
    } catch (error) {
      console.error("Error updating priority:", error);
      throw error;
    }
  }

  async deletePriority(priorityId: string): Promise<void> {
    try {
      await apiCall("/deletePriority", {
        method: "POST",
        body: JSON.stringify({ priorityId }),
      });
    } catch (error) {
      console.error("Error deleting priority:", error);
      throw error;
    }
  }

  async changePriorityOrder(priorityId: string, newOrder: number): Promise<{ priority: Priority; priorities: Priority[] }> {
    try {
      const response = await apiCall("/changePriorityOrder", {
        method: "POST",
        body: JSON.stringify({ priorityId, newOrder }),
      });
      return { priority: response.priority, priorities: response.priorities };
    } catch (error) {
      console.error("Error changing priority order:", error);
      throw error;
    }
  }

  async getPriorityStats(): Promise<PriorityStats> {
    try {
      const response = await apiCall("/getPriorityStats");
      return response.stats;
    } catch (error) {
      console.error("Error fetching priority stats:", error);
      throw error;
    }
  }
}

export const priorityService = new PriorityService();
